import { ADMITAD_ENABLED } from 'const';

/* CONSTANTS BLOCK */
const UTM_COOKIE_LIFETIME_DAYS = 90;
const UTM_COOKIE_NAME = 'utm_params_admitad';
const CROSSDOMAIN_PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  // If you need to transfer other params between domains, add them below, e.g.:
  'tagtag_uid',
  'admitad_uid',
];
/* END OF CONSTANTS BLOCK */

function getCookie(name: string) {
  const matches = document.cookie.match(
    new RegExp(
      '(?:^|; )' +
        name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') +
        '=([^;]*)',
    ),
  );
  return matches ? decodeURIComponent(matches[1]) : null;
}

function setCookie(name: string, value: string, lifetimeDays: number) {
  const periodMillis = lifetimeDays * 24 * 60 * 60 * 1000;
  const expiresDate = new Date(new Date().getTime() + periodMillis);
  const cookieString =
    name + '=' + value + '; path=/; expires=' + expiresDate.toUTCString();
  document.cookie = cookieString;
  document.cookie = cookieString + '; domain=.' + window.location.host;
}

function collectCrossDomainParams(): string {
  const pageUrl = new URL(window.location.href);
  const params = new URLSearchParams();

  const storedParams = getCookie(UTM_COOKIE_NAME);
  if (storedParams) {
    const stored = new URLSearchParams(storedParams);
    stored.forEach((value, key) => {
      if (value?.trim()) {
        params.set(key, value.trim());
      }
    });
  }

  for (let i = 0; i < CROSSDOMAIN_PARAMS.length; i++) {
    const param = CROSSDOMAIN_PARAMS[i];
    const fromUrl = pageUrl.searchParams.get(param)?.trim();
    if (fromUrl) {
      params.set(param, fromUrl);
      continue;
    }

    if (param === 'admitad_uid') {
      const fromCookie = getCookie('admitad_uid')?.trim();
      if (fromCookie) {
        params.set(param, fromCookie);
      }
    }
  }

  return params.toString();
}

function addParamsToLinks(paramsString: string) {
  const links = document.getElementsByTagName('a');

  for (let i = 0; i < links.length; i++) {
    const link = links[i];
    if (link.host === window.location.host || link.host === '') {
      continue;
    }
    try {
      const linkUrl = new URL(link.href);
      if (linkUrl.search) {
        linkUrl.search += '&' + paramsString;
      } else {
        linkUrl.search = '?' + paramsString;
      }
      link.href = linkUrl.toString();
    } catch (err) {}
  }
}

export const getAdmitadCrossDomainQuery = (): string => {
  if (!ADMITAD_ENABLED) {
    return '';
  }
  return collectCrossDomainParams();
};

export const initAdmitadCrossdomainScript = () => {
  if (!ADMITAD_ENABLED) {
    return;
  }
  const utmParams = collectCrossDomainParams();
  if (utmParams) {
    setCookie(UTM_COOKIE_NAME, utmParams, UTM_COOKIE_LIFETIME_DAYS);
    addParamsToLinks(utmParams);
  }
};
